var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-layout"},[_c('Header'),_c('left-sidebar'),_c('div',{staticClass:"layout-page"},[(_vm.breadcrumbs)?_c('breadcrumbs-menu',{attrs:{"items":_vm.breadcrumbs}}):_vm._e(),_c('div',{staticClass:"page-content",class:{ fixed: _vm.fixedWidth }},[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }